import { render, staticRenderFns } from "./body-interview.vue?vue&type=template&id=0f62be61&scoped=true"
import script from "./body-interview.vue?vue&type=script&lang=js"
export * from "./body-interview.vue?vue&type=script&lang=js"
import style0 from "./body-interview.vue?vue&type=style&index=0&id=0f62be61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f62be61",
  null
  
)

export default component.exports